import { render, staticRenderFns } from "./CustomerBasedata.vue?vue&type=template&id=3fa0f070"
import script from "./CustomerBasedata.vue?vue&type=script&lang=js"
export * from "./CustomerBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports